import React from 'react';
import { TextField, Typography, Button } from '@mui/material';

const PostalCodeSection = ({
  register,
  errors,
  dataRowEdit,
  postalCodeValue,
  isPostalCodeValid,
  responseZipCode,
  handleSearchAndClear,
}) => {
  return (
    <>
      <TextField
        label='Código postal'
        variant='outlined'
        fullWidth
        margin='normal'
        defaultValue={dataRowEdit?.zipcode}
        {...register('postalCode', {
          required: 'Código postal es obligatorio',
          pattern: {
            value: /^[0-9]{5}$/,
            message: 'El código postal debe tener 5 dígitos',
          },
        })}
        error={errors.postalCode}
        helperText={errors.postalCode?.message}
        sx={{ backgroundColor: '#fff', borderRadius: '4px' }}
        slotProps={{
          inputLabel: {
            shrink: postalCodeValue,
          },
        }}
      />
      {((!isPostalCodeValid && postalCodeValue !== '') ||
        responseZipCode?.status ||
        responseZipCode?.code === 'ERR_NETWORK') && (
        <Typography color='error' variant='body2'>
          {!isPostalCodeValid && postalCodeValue !== ''
            ? 'Ingresa un código postal de 5 digitos para buscar.'
            : responseZipCode.status === 404
              ? 'Código postal no encontrado.'
              : 'Ocurrió un error al buscar el código postal.'}
        </Typography>
      )}
      <Button
        disabled={!isPostalCodeValid}
        onClick={handleSearchAndClear}
        variant='contained'
        color='secondary'
        fullWidth
        sx={{ backgroundColor: '#AD6C56', mt: 1, mb: 2 }}
      >
        Buscar
      </Button>
    </>
  );
};

export default PostalCodeSection;
